"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _useId = _interopRequireDefault(require("@mui/utils/useId"));
var _default = exports.default = _useId.default;